import { useState } from 'react'
import Button from '../../../components/common/Button'
import Input from '../../../components/common/Input'
import PasswordInput from '../../../components/common/PasswordInput'
import PasswordStrengthMeter, { isPasswordValid, validatePasswordStrength } from '../../../components/common/PasswordStrengthMeter'

// Password generator utility
const generateSecurePassword = () => {
  const lowercase = 'abcdefghijklmnopqrstuvwxyz'
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const numbers = '0123456789'
  const special = '!@#$%^&*()_+-=[]{}|;:,.<>?'

  let password = ''
  password += uppercase[Math.floor(Math.random() * uppercase.length)]
  password += numbers[Math.floor(Math.random() * numbers.length)]
  password += special[Math.floor(Math.random() * special.length)]

  const allChars = lowercase + uppercase + numbers + special
  for (let i = password.length; i < 12; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)]
  }

  return password.split('').sort(() => Math.random() - 0.5).join('')
}

const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(email)
}

const AdminCreationStep = ({ formData, setFormData, onNext, onBack, loading, error }) => {
  const passwordStrength = validatePasswordStrength(formData.adminPassword)
  const isValid = isPasswordValid(formData.adminPassword) && validateEmail(formData.adminEmail)

  return (
    <div className="animate-fade-in">
      <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
        Criar Usuário Administrador
      </h2>

      <div className="space-y-4 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-900 dark:text-gray-100 mb-2">
            Usuário
          </label>
          <div className="flex items-center gap-3 px-4 py-3 rounded-lg bg-gray-100 dark:bg-gray-700 border border-gray-300 dark:border-gray-600">
            <span className="material-icons text-gray-500 dark:text-gray-400">account_circle</span>
            <span className="font-medium text-gray-900 dark:text-white">administrador</span>
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
            Usuário padrão fixo para administradores
          </p>
        </div>

        <Input
          label="Email"
          type="email"
          placeholder="seu.email@empresa.com"
          value={formData.adminEmail}
          onChange={(e) => setFormData({ ...formData, adminEmail: e.target.value })}
          error={formData.adminEmail && !validateEmail(formData.adminEmail) ? 'Email inválido' : ''}
          disabled={loading}
          icon={<span className="material-icons text-sm">mail</span>}
        />

        <div>
          <div className="flex items-center justify-between mb-2">
            <label className="block text-sm font-medium text-gray-900 dark:text-gray-100">
              Senha
            </label>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setFormData({ ...formData, adminPassword: generateSecurePassword() })}
              disabled={loading}
              className="text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300"
            >
              <span className="material-icons text-sm">refresh</span>
              Gerar
            </Button>
          </div>
          <PasswordInput
            value={formData.adminPassword}
            onChange={(e) => setFormData({ ...formData, adminPassword: e.target.value })}
            placeholder="Crie uma senha forte"
            disabled={loading}
          />

          <PasswordStrengthMeter password={formData.adminPassword} />
        </div>
      </div>

      {error && (
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6">
          <p className="text-red-800 dark:text-red-200 text-sm">{error}</p>
        </div>
      )}

      <div className="flex gap-3">
        <Button variant="secondary" onClick={onBack} disabled={loading} className="flex-1">
          Voltar
        </Button>
        <Button variant="primary" onClick={onNext} loading={loading} disabled={!isValid} className="flex-1">
          Continuar
        </Button>
      </div>
    </div>
  )
}

export default AdminCreationStep
